module.exports = __webpack_public_path__ + "img/img107.40cc4e90.svg";